import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import { Currency } from "./currency.model";

export const ACTION_PREFIX = "[Currency]";
export const CURRENCY_ACTION_TYPE = {
	initialize: `${ACTION_PREFIX} Initialize`,
	initializeSuccess: `${ACTION_PREFIX} Initialize Success`,
	initializeFail: `${ACTION_PREFIX} Initialize Fail`,

	setCustomerCurrencySuccess: `${ACTION_PREFIX} Set Customer Currency Success ${SYNC_SUFFIX}`,
	setCustomerCurrencyFail: `${ACTION_PREFIX} Set Customer Currency Fail ${SYNC_SUFFIX}`,

	set: `${ACTION_PREFIX} Set`,
	setSuccess: `${ACTION_PREFIX} Set Success`,
	setFail: `${ACTION_PREFIX} Set Fail`,

	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,
};

@Injectable({
	providedIn: "root",
})
export class CurrencyAction {
	initialize(): Action {
		return {
			type: CURRENCY_ACTION_TYPE.initialize,
		};
	}

	initializeSuccess(): Action {
		return {
			type: CURRENCY_ACTION_TYPE.initializeSuccess,
		};
	}

	initializeFail(error: AppError): ActionWithPayload {
		return {
			type: CURRENCY_ACTION_TYPE.initializeFail,
			payload: error,
		};
	}

	setCustomerCurrencySuccess(): Action {
		return {
			type: CURRENCY_ACTION_TYPE.setCustomerCurrencySuccess,
		};
	}

	setCustomerCurrencyFail(error: AppError): ActionWithPayload {
		return {
			type: CURRENCY_ACTION_TYPE.setCustomerCurrencyFail,
			payload: error,
		};
	}

	set(currencyCode: string): ActionWithPayload {
		return {
			type: CURRENCY_ACTION_TYPE.set,
			payload: currencyCode,
		};
	}

	setSuccess(): Action {
		return {
			type: CURRENCY_ACTION_TYPE.setSuccess,
		};
	}

	setFail(error: AppError): ActionWithPayload {
		return {
			type: CURRENCY_ACTION_TYPE.setFail,
			payload: error,
		};
	}

	getAll(): Action {
		return createCachedGetAction({
			type: CURRENCY_ACTION_TYPE.getAll,
		});
	}

	getAllSuccess(currencies: Currency[]): ActionWithPayload {
		return createGetSuccessAction({
			type: CURRENCY_ACTION_TYPE.getAllSuccess,
			payload: currencies,
		});
	}

	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: CURRENCY_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}
}
